import { Goal } from './Goal';

export const kind = 'Stop';

// DEPRECATED: Under Replication V2, `Stop` does not really do anything useful:
// * `Disable` is the action that's dispatched during `RxdbManager.stopReplication(true)`, not `Stop`.
// * The conditions that use to call `RxdbManager.stopReplication(false)` all have their own actions:
//   * Going offline now dispatches `NetworkChanged`
//   * `msBorerSync.allowSync` is now baked into `lifecycle/start`
//   * `borerSelected` changes use `SelectBorer`.
// * Which means that `reduceLifeCycle` will automatically restart replication after `Stop` triggers a `suspend`
//   if all of the replication conditions are met.
// * Which makes `Stop` equivalent to a `Restart`, and thus is not necessary.
// TODO: clean this up https://nutrien.atlassian.net/browse/MDP-8188
export type Stop = Goal<typeof kind>;
